import React, { useState } from 'react';
import s from './Purchases.module.scss';
import { ReactComponent as IconUploadBg } from 'images/new-icons/image-loader.svg';

const UploadImageItems = [
  { id: 'entire', name: 'Entire product' },
  { id: 'packaging', name: 'Packaging with barcode' },
  { id: 'defect', name: 'Defect' },
  { id: 'expiration', name: 'Expiration date' },
];

const LoadingSpinner = () => (
  <div className={s.spinner}>
    <div className={s.doubleBounce1}></div>
    <div className={s.doubleBounce2}></div>
  </div>
);

const UploadImage = ({ mediaUrls, setMediaUrls }) => {
  const [isMediaLoading, setIsMediaLoading] = useState<Record<string, boolean>>({});

  const uploadToCloudinary = async file => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'ml_default');

    const uploadEndpoint = file.type.startsWith('video')
      ? `${process.env.REACT_APP_CLOUDINARY_URL}/video/upload`
      : `${process.env.REACT_APP_CLOUDINARY_URL}/image/upload`;

    try {
      const response = await fetch(uploadEndpoint, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        return data.secure_url;
      } else {
        console.error('Ошибка загрузки в Cloudinary:', await response.json());
        return null;
      }
    } catch (error) {
      console.error('Ошибка загрузки файла:', error);
      return null;
    }
  };

  const onBgUpload = async (e: React.ChangeEvent<HTMLInputElement>, itemId: string) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setIsMediaLoading(prev => ({ ...prev, [itemId]: true }));

    try {
      const url = await uploadToCloudinary(file);
      if (url) {
        setMediaUrls(prev => ({ ...prev, [itemId]: url }));
      }
    } catch (err) {
      console.error('Upload error:', err);
    } finally {
      setIsMediaLoading(prev => ({ ...prev, [itemId]: false }));
    }
  };

  const renderUploadContent = (itemId) => {
    if (isMediaLoading[itemId]) {
      return <LoadingSpinner />;
    }

    if (mediaUrls[itemId]) {
      if (mediaUrls[itemId].endsWith('.mp4') || mediaUrls[itemId].includes('video')) {
        return (
          <video controls playsInline muted className={s.uploadedMedia}>
            <source src={mediaUrls[itemId]} type="video/mp4" />
          </video>
        );
      }
      return <img src={mediaUrls[itemId]} alt="" className={s.uploadedMedia} />;
    }

    return <IconUploadBg />;
  };

  return (
    <div className={s.upload_image}>
      <div className={s.upload_image_title}>Upload photo</div>
      <div className={s.upload_image_description}>
        <div className={s.upload_image_description_title}>Upload photo or video</div>
        <div className={s.upload_image_description_text}>
          Please upload clear photos of the product and its packaging to help us process your refund faster.
        </div>
      </div>
      {UploadImageItems.map(item => (
        <div key={item.id} className={s.upload_image_upload}>
          <form className={s.bgUploadLabel}>
            <label htmlFor={`upload_${item.id}`}>
              <input
                type="file"
                name="file"
                id={`upload_${item.id}`}
                className={s.bgUploadInput}
                onChange={(e) => onBgUpload(e, item.id)}
                accept={'image/*, video/*'}
              />
              {renderUploadContent(item.id)}
            </label>
          </form>
          <div className={s.upload_image_upload_text}>{item.name}</div>
        </div>
      ))}
    </div>
  );
};

export default UploadImage;
